module.exports = {
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "title": "深化數位學習平台資料管理",
  "description": "",
  "properties": {
    "title": {
      "type": "string",
      "minLength": 3,
      "maxLength": 80,
      "title": "系列名稱",
      "attrs": {
        "placeholder": "例如：摩課師課程",
        "title": "請輸入系列名稱"
      }
    },
    "title-2": {
      "type": "string",
      "minLength": 3,
      "maxLength": 80,
      "title": "系列次標題",
      "properties": {
        "attrs": {
          "placeholder": "1234",
        }
      },
      "attrs": {
        "placeholder": "例如：外國語文學院 日文系 英文系",
        "title": "請輸入系列次標題，通常為學院 (系) 的名稱"
      }
    },
    "sub": {
      "title": "SubTitle",
      "description": "SubDescription",
      "type": "object",
      "properties": {
        "sName": {
          "minLength": 8,
          "maxLength": 80,
          "title": "SubName",
          "attrs": {
            "placeholder": "Sub Full Name",
            "title": "Please enter your full name"
          }
        },
        "sUrl": {
          "title": "SubUrl",
          "format": "uri"
        },
        "sub2": {
          "type": "object",
          "title": "Sub2Title",
          "description": "Sub2Description",
          "properties": {
            "sName2": {
              "format": "regex",
              "title": "Sub2Name",
              "pattern": "*"
            },
            "sAge": {
              "type": "integer",
              "title": "Sub2Age"
            }
          },
          "required": [ "sName2" ]
        }
      },
      "required": ["sUrl"]
    },
    "lists": {
      "type": "string",
      "title": "List",
      "enum": ["Daily New", "Promotion"],
      "attrs": {
        "placeholder": "Select your list subscription",
        "title": "Please select your list subscription"
      }
    },
    "lists2": {
      "type": "array",
      "title": "List2",
      "anyOf": [
        { "value": "daily", "label": "Daily New" },
        { "value": "promotion", "label": "Promotion" }
      ],
      "attrs": {
        "placeholder": "Select your list subscription",
        "title": "Please select your list subscription"
      }
    },
    "lists3": {
      "type": "array",
      "title": "List3",
      "oneOf": [
        { "value": "daily", "label": "Daily New" },
        { "value": "promotion", "label": "Promotion" }
      ]
    },
    "source": {
      "type": "string",
      "maxLength": 120,
      "title": "Source",
      "description": "Ex. Using the NPM Search Engine",
      "attrs": {
        "type": "textarea",
        "placeholder": "How did you hear about us?"
      }
    },
    "rate": {
      "type": "number",
      "title": "Rate",
      "default": 2,
      "attrs": {
        "type": "rate",
        "allow-half": true
      }
    },
    "color": {
      "type": "string",
      "title": "Color",
      "default": "#409EFF",
      "attrs": {
        "type": "color"
      }
    },
    "agree": {
      "type": "boolean",
      "title": "Agree",
      "description": "You agree to receive occasional updates and special offers for vue-json-schema updates.",
      "default": false,
      "attrs": {
        "type": "switch"
      }
    }
  },
  "additionalProperties": false,
  "required": ["title", "email", "lists"]
}



// WEBPACK FOOTER //
// ./src/series-data-schema.js